import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0292407c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "program-participation-detail" }
const _hoisted_2 = { class: "header d-flex align-items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "group border-bottom" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "list" }
const _hoisted_8 = { class: "item" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { class: "item" }
const _hoisted_12 = { class: "label" }
const _hoisted_13 = { class: "value" }
const _hoisted_14 = { class: "item" }
const _hoisted_15 = { class: "label" }
const _hoisted_16 = { class: "value" }
const _hoisted_17 = { class: "item" }
const _hoisted_18 = { class: "label" }
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "item address" }
const _hoisted_21 = { class: "label" }
const _hoisted_22 = { class: "value" }
const _hoisted_23 = { class: "group" }
const _hoisted_24 = { class: "title" }
const _hoisted_25 = { class: "filter-box d-flex" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 0,
  class: "list"
}
const _hoisted_28 = { class: "item" }
const _hoisted_29 = { class: "label" }
const _hoisted_30 = { class: "value" }
const _hoisted_31 = { class: "item" }
const _hoisted_32 = { class: "label" }
const _hoisted_33 = { class: "value" }
const _hoisted_34 = { class: "item" }
const _hoisted_35 = { class: "label" }
const _hoisted_36 = { class: "value" }
const _hoisted_37 = { class: "item" }
const _hoisted_38 = { class: "label" }
const _hoisted_39 = { class: "value" }
const _hoisted_40 = { class: "item" }
const _hoisted_41 = { class: "label" }
const _hoisted_42 = { class: "value" }
const _hoisted_43 = { class: "item" }
const _hoisted_44 = { class: "label" }
const _hoisted_45 = { class: "value" }
const _hoisted_46 = { class: "item" }
const _hoisted_47 = { class: "label" }
const _hoisted_48 = { class: "value" }
const _hoisted_49 = {
  key: 0,
  class: "void-tips"
}
const _hoisted_50 = {
  key: 0,
  class: "item"
}
const _hoisted_51 = { class: "label" }
const _hoisted_52 = { class: "value" }
const _hoisted_53 = {
  key: 2,
  class: "progress-box"
}

import { computed, ref } from 'vue';
  import _ from 'lodash';
  import { USER_REQUEST_STATE_MAP, SHIPMENT_STATE_MAP, PEOPLE_COLLECTION_MAP } from '@/constants';
  import ShipmentProgress from './shipment-progress.vue';
  import { ProgramDetail } from './index';
  import { useI18n } from 'vue-i18n';
  import { confirm, request, alert } from '@/utils';
  import { authStore } from '@/stores';
  import Note from './note.vue';
  import type { UserRequestProgramShipment } from '@/types/user-request';

  interface IProps {
    detail: ProgramDetail,
    list: UserRequestProgramShipment[]
  }
  interface IEmits {
    (event: 'reload'): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    detail: null,
    list: null
  },
  emits: ["reload"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'reload'): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    detail: ProgramDetail,
    list: UserRequestProgramShipment[]
  }

  const { t, locale } = useI18n();

  
  
  const stateMap = SHIPMENT_STATE_MAP;
  const filterNames = ['1st', '2nd', '3rd'].concat(_.range(4, 21).map(item => `${item}th`));
  const banner = computed(() => {
    return _.get(props.detail, 'target.image.url');
  });
  const currentIndex = ref(0);
  const currentCollection = computed(() => {
    return props.list[currentIndex.value];
  });
  const personalAddress = computed(() => {
    const profile = authStore.user.profile;
    return [profile?.street_address, profile?.extended_address].filter(Boolean).join(',');
  });

  const handleTrigger = (index: number) => {
    currentIndex.value = index;
  };

  const handleShipmentOperation = async (type: string) => {
    await confirm(type === 'cancel' ? t('Confirm cancellation?') : t('Confirm request?'));
    await request.post(`program_shipments/${currentCollection.value.id}/${type === 'cancel' ? 'cancel' : 'request_again'}`);
    alert({ title: t('Success'), content: type === 'cancel' ? t('Collection request has been completed') : t('Operation success'), });
    emits('reload');
  };

return (_ctx: any,_cache: any) => {
  const _component_AppTimeFormat = _resolveComponent("AppTimeFormat")!
  const _component_AppEmptyView = _resolveComponent("AppEmptyView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: _unref(banner),
        class: "banner"
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, _toDisplayString(__props.detail.target.name), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('Program Information')), 1),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)('Program Submission day')), 1),
          _createElementVNode("span", _hoisted_10, [
            _createVNode(_component_AppTimeFormat, {
              time: __props.detail.created_at,
              format: "YYYY-MM-DD"
            }, null, 8, ["time"])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)('Type of Participation')), 1),
          _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(PEOPLE_COLLECTION_MAP)[__props.detail.people_collection]), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(t)('Status of application for activities')), 1),
          _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(USER_REQUEST_STATE_MAP)[__props.detail.state]), 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(t)('Rounds')), 1),
          _createElementVNode("span", _hoisted_19, _toDisplayString(__props.detail.human_program_round_time_range || '/'), 1)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(t)('My address')), 1),
          _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(personalAddress) || '/'), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(t)('Collection Information')), 1),
      _createElementVNode("div", _hoisted_25, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item, index) => {
          return (_openBlock(), _createElementBlock("span", {
            key: item.id,
            class: _normalizeClass(["item", { active: index === currentIndex.value}]),
            onClick: ($event: any) => (handleTrigger(index))
          }, _toDisplayString(_unref(filterNames)[index]), 11, _hoisted_26))
        }), 128))
      ]),
      (_unref(currentCollection))
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(t)('Quantity')), 1),
              _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(currentCollection).quantity || 1), 1)
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(t)('Weight')), 1),
              _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(currentCollection).collected_item.weight || '/'), 1)
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("span", _hoisted_35, _toDisplayString(_unref(t)('Tracking number')), 1),
              _createElementVNode("span", _hoisted_36, _toDisplayString(_unref(currentCollection).no || '/'), 1)
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("span", _hoisted_38, _toDisplayString(_unref(t)('Date created')), 1),
              _createElementVNode("span", _hoisted_39, [
                _createVNode(_component_AppTimeFormat, {
                  time: _unref(currentCollection).created_at,
                  format: "YYYY-MM-DD"
                }, null, 8, ["time"])
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("span", _hoisted_41, _toDisplayString(_unref(t)('Date received')), 1),
              _createElementVNode("span", _hoisted_42, [
                _createVNode(_component_AppTimeFormat, {
                  time: _unref(currentCollection).received_at,
                  format: "YYYY-MM-DD"
                }, null, 8, ["time"])
              ])
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("span", _hoisted_44, _toDisplayString(_unref(t)('Points earned')), 1),
              _createElementVNode("span", _hoisted_45, _toDisplayString(_unref(currentCollection).points_earned || '/'), 1)
            ]),
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, _toDisplayString(_unref(t)('Status of colletion shippment')), 1),
              _createElementVNode("div", _hoisted_48, [
                _createTextVNode(_toDisplayString(_unref(stateMap)[_unref(currentCollection).state]) + " ", 1),
                (_unref(currentCollection).state === 'void' && _unref(currentCollection).void_reason)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(_unref(currentCollection).void_reason), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            (_unref(locale) === 'ja')
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                  _createElementVNode("span", _hoisted_51, _toDisplayString(_unref(t)('remark')), 1),
                  _createElementVNode("span", _hoisted_52, [
                    (_unref(currentCollection))
                      ? (_openBlock(), _createBlock(Note, {
                          key: 0,
                          id: _unref(currentCollection).id,
                          note1: _unref(currentCollection).note1,
                          note2: _unref(currentCollection).note2,
                          state: _unref(currentCollection).state,
                          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('reload')))
                        }, null, 8, ["id", "note1", "note2", "state"]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (!__props.list.length)
        ? (_openBlock(), _createBlock(_component_AppEmptyView, {
            key: 1,
            text: _unref(t)('No collection application record')
          }, null, 8, ["text"]))
        : _createCommentVNode("", true),
      (_unref(currentCollection))
        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
            _createVNode(ShipmentProgress, {
              state: _unref(currentCollection).state,
              unmatched: _unref(currentCollection).unmatched,
              "show-cancel-btn": _unref(currentCollection).show_cancel_btn,
              "show-request-again-btn": _unref(currentCollection).show_request_again_btn,
              onCancel: _cache[1] || (_cache[1] = ($event: any) => (handleShipmentOperation('cancel'))),
              onRequest: _cache[2] || (_cache[2] = ($event: any) => (handleShipmentOperation('request')))
            }, null, 8, ["state", "unmatched", "show-cancel-btn", "show-request-again-btn"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})